export type TabKey = 'resume' | 'web' | 'electronics' | 'software';

export type PortfolioObject = {
  type: TabKey,
  title: string,
  dateRange: string,
  description: string,
  source?: String,
  link?: string,
}

export const portfolioItems: PortfolioObject[] = [
    {
      type: 'web',
      title: "This Website",
      dateRange: "February 2020 - Current",
      description: "My portfolio website, as of today, is constructed entirely with HTML, CSS, and JavaScript. It's had many looks and phases over the years but my current objective is to create an OS-like appearance and functionality to showcase my skills. ",
      source: '/assets/images/projects/home_11_27_21.JPG',
    },
    {
      type: 'web',
      title: "Brushed Hair Studio",
      dateRange: "February 2020 - Current",
      description: "A simple and responsive static website created for a local hair studio. ",
      source: '/assets/images/projects/tas_updated.png',
    },
    {
      type: 'web',
      title: "Sienna Search",
      dateRange: "December 2021",
      description: "A simple search engine with web interface developed as a final project for an Information retrival class. The program crawls over 50,000 web urls and utilizes a lightweight ranking algorithm to efficiently return query results. ",
      source: '/assets/images/projects/sienna_search.JPG',
    },
    {
      type: 'software',
      title: 'Billiards Computer Vision',
      dateRange: '',
      description: 'A Raspberry Pi and Python OpenCV project that runs object detection on video recordings of billiards games to track stats and produce game analytics.',
    },
    {
      type: 'software',
      title: "TiP App Stack",
      dateRange: "August 2021 - January 2022",
      description: "A .NET application developed during my time as an Applications Developer for the architecture firm CannonDesign. The app consists of a library ",
      source: '/assets/images/projects/tas_updated.png',
    },
    {
      type: 'electronics',
      title: 'Altoids Tin Can Arduino Display',
      dateRange: '',
      description: 'An Arduino Uno encased within an Altoids tin can, wired to a pinout OLED display that cycles through custom animations.',
    },
  ];